/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Dataroom_File2Inputs */

const en_coinvestments_dataroom_file2 = /** @type {(inputs: Coinvestments_Dataroom_File2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`File`)
};

/**
* | output |
* | --- |
* | "File" |
*
* @param {Coinvestments_Dataroom_File2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_dataroom_file2 = /** @type {((inputs?: Coinvestments_Dataroom_File2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Dataroom_File2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_dataroom_file2(inputs)
});
export { coinvestments_dataroom_file2 as "coInvestments_dataRoom_file" }